<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_tit"></a><a id="page_iii"></a><span class="small">BARBARA JORDAN</span></h1>
<p class="subtitle"><em>Speaking the Truth with Eloquent Thunder</em></p>
<p class="author"><span class="small">EDITED BY MAX SHERMAN</span></p>
<p class="publisher"> </p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_tit.vue?3f45a2c4